import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { TypeFNSSimpleDescMarche2 } from '../../models/TypeFNSSimpleDescMarche2';
import { TypeNatureMarcheChoix } from '../../models/TypeNatureMarcheChoix';
import { TypeCPVClass } from '../../models/TypeCPVClass';
import { TypeObjCPV } from '../../models/TypeObjCPV';
import { SimpREControlNames } from '../simpREControleNames';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class DescriptionService {
  constructor(private avisDataTransferService: AvisDataTransferService) { }

  public getDescription(
    controls: any,
    formExtractorService: FormExtractorService,
    stepId
  ): TypeFNSSimpleDescMarche2 {


    const description = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.rectificatifFromFNSimple.natureMarche;
    if (stepId === 3) {
      description.criteresAttrib = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_criteresAttrib')
    }
    if (stepId === 4) {
      description.intitule = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_intitule');
      description.description = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_description');

      description.codeCPV = new TypeObjCPV();
      description.codeCPV.objetPrincipal = new TypeCPVClass();
      description.codeCPV.objetPrincipal.classPrincipale = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepSep_TypeObjCPV_objetPrincipal_SepSep_TypeCPVClass_SepAtt_classPrincipale');

      description.natureMarche = new TypeNatureMarcheChoix();
      description.natureMarche.travaux = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_natureMarche') == RadioCheckBoxEnum.travauxValue ? '' : null;
      description.natureMarche.fournitures = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_natureMarche') == RadioCheckBoxEnum.fournituresValue ? '' : null;
      description.natureMarche.services = controls.get('_SepSep_TypeAnn_SepSep_Rectificatif_SepSep_TypeDescMarche_SepAtt_natureMarche') == RadioCheckBoxEnum.servicesValue ? '' : null;
    }
    return description;
  }
}
